// The signing page's outcome mark. With `animate`, the moment it happens:
// the mark draws in, in its colour; a ring draws a full circle around it;
// then the circle fills with the colour and the mark turns white. Without
// it (a page opened afterwards), the finished mark: the filled circle with
// the white mark. `declined` makes it the red X a decline gets; otherwise
// it is the green check a signature gets. The timing lives in index.css
// (.signed-check); reduced motion shows the finished mark at once.
export default function SignedCheck({ animate = false, size = 72, declined = false }) {
  return (
    <svg className={`signed-check${animate ? " is-animating" : ""}${declined ? " is-declined" : ""}`} width={size} height={size} viewBox="0 0 96 96" aria-hidden="true" focusable="false">
      <circle className="sc-ring" cx="48" cy="48" r="42" />
      <circle className="sc-fill" cx="48" cy="48" r="42" />
      {declined
        ? <path className="sc-tick" d="M35 35 L61 61 M61 35 L35 61" />
        : <path className="sc-tick" d="M30 50 L43 62 L67 36" />}
    </svg>
  );
}
